import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [participantId, setParticipantId] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false); // добавили флаг

  useEffect(() => {
    const initAuth = async () => {
      const savedUser = localStorage.getItem('user');
      const savedToken = localStorage.getItem('access_token');
      const savedRefresh = localStorage.getItem('refresh_token');
      const savedParticipant = localStorage.getItem('participant_id');

      if (savedUser && savedToken) {
        setUser(JSON.parse(savedUser));
        setToken(savedToken);
        setRefreshToken(savedRefresh);
      }

      if (savedParticipant) {
        setParticipantId(Number(savedParticipant));
      }

      // Если своих токенов нет - попробуем залогиниться через UCP
      if (!savedToken) {
        try {
          const res = await fetch('/api/auth/ucp-login', {
            credentials: 'include', // на всякий случай, хотя запрос same-origin
          });

          if (res.ok) {
            const data = await res.json();
            // структура такая же, как у /auth/login:
            // { user, access_token, refresh_token, participant_id }
            setUserData(data.user, data.access_token, data.refresh_token, data.participant_id);
          }
        } catch (e) {
          // Тихо логируем, чтобы не мешать обычному UI
          console.error('UCP SSO login failed', e);
        }
      }

      setIsInitialized(true);
    };

    void initAuth();
  }, []);

  const setUserData = (userData, accessToken, refreshToken, participantId) => {
    setUser(userData);
    setToken(accessToken);
    setRefreshToken(refreshToken);
    setParticipantId(participantId);

    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('refresh_token', refreshToken);
    localStorage.setItem('participant_id', participantId);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setRefreshToken(null);
    setParticipantId(null);

    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('participant_id');
  };

  return (
    <UserContext.Provider
      value={{ user, token, refreshToken, participantId, setUserData, logout, isInitialized }}
    >
      {children}
    </UserContext.Provider>
  );
};
